export default "__VITE_ASSET__BkXPhhMw__"